import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { saveExtrication } from '../../procedures/extrication/store/extrication.actions'
import { QuickActionsConstants } from '../store/quickActions.constants'

export function* setExtricationQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addExtricationToTimeline } = quickActionsObject
  if (addExtricationToTimeline) {
    yield put(saveExtrication())
  }
}

export function* setExtricationQuickActionTimeLineRowSaga() {
  yield takeLatest([QuickActionsConstants.SET_ADD_EXTRICATION_TO_TIMELINE], setExtricationQuickActionTimeLineRow)
}
